import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@repo/videa-components/src/index';
import type { ButtonProps } from '@repo/videa-components/src/ui/button';
import classNames from 'classnames';

interface Props extends ButtonProps {
  dataCy?: string;
  icon?: IconProp;
  isActive: boolean;
}

export const ToolbarButton = ({
  children,
  className,
  dataCy,
  dataTestId,
  disabled,
  icon,
  isActive,
  onClick,
  variant = 'icon',
}: Props) => {
  return (
    <Button
      className={classNames(className, {
        'max-[880px]:!vai-w-7 max-[880px]:!vai-h-7 min-[880px]:!vai-w-9 min-[880px]:!vai-h-9':
          variant === 'icon',
        'active !vai-bg-[#0A0A0A] hover:!vai-opacity-70': isActive,
        '!vai-bg-transparent hover:!vai-bg-[#212734]': !isActive,
        'vai-cursor-not-allowed hover:!vai-bg-transparent': disabled,
        'vai-text-zinc-50': variant !== 'icon',
        '!vai-text-zinc-400 hover:!vai-text-slate-200':
          variant !== 'icon' && !isActive,
      })}
      data-cy={dataCy}
      data-testid={dataTestId}
      onClick={onClick}
    >
      {children}
      {icon && (
        <FontAwesomeIcon
          className={classNames('vai-text-slate-200', {
            'vai-text-zinc-500': disabled,
          })}
          icon={icon}
        />
      )}
    </Button>
  );
};
